import us from "@/data/countries/us.json";
import gb from "@/data/countries/gb.json";
import au from "@/data/countries/au.json";
import ca from "@/data/countries/ca.json";
import sg from "@/data/countries/sg.json";
import inRules from "@/data/countries/in.json";
import nz from "@/data/countries/nz.json";
import de from "@/data/countries/de.json";
import ch from "@/data/countries/ch.json";
import nl from "@/data/countries/nl.json";
import { supplementalGlossaryByCountry } from "@/data/glossary/country-supplemental-glossary";

import { CountryRules } from "./types";

export const countries = [
  { code: "us", name: "United States", flag: "🇺🇸", currency: "USD" },
  { code: "gb", name: "United Kingdom", flag: "🇬🇧", currency: "GBP" },
  { code: "au", name: "Australia", flag: "🇦🇺", currency: "AUD" },
  { code: "ca", name: "Canada", flag: "🇨🇦", currency: "CAD" },
  { code: "sg", name: "Singapore", flag: "🇸🇬", currency: "SGD" },
  { code: "in", name: "India", flag: "🇮🇳", currency: "INR" },
  { code: "nz", name: "New Zealand", flag: "🇳🇿", currency: "NZD" },
  { code: "de", name: "Germany", flag: "🇩🇪", currency: "EUR" },
  { code: "ch", name: "Switzerland", flag: "🇨🇭", currency: "CHF" },
  { code: "nl", name: "Netherlands", flag: "🇳🇱", currency: "EUR" },
];

const rulesMap: Record<string, any> = {
  us,
  gb,
  au,
  ca,
  sg,
  in: inRules,
  nz,
  de,
  ch,
  nl,
};

export function getCountryRules(countryCode: string): CountryRules {
  const code = countryCode.toLowerCase();
  const rules = rulesMap[code];
  if (!rules) {
    throw new Error(`Country rules not found for country code: ${countryCode}`);
  }

  const supplementalGlossary = supplementalGlossaryByCountry[code] || [];
  const existingTerms = new Set((rules as CountryRules).glossary.map((item) => item.term.toLowerCase()));

  return {
    ...(rules as CountryRules),
    glossary: [...(rules as CountryRules).glossary, ...supplementalGlossary.filter((item) => !existingTerms.has(item.term.toLowerCase()))],
  };
}

export function getSupportedCountries() {
  return Object.keys(rulesMap);
}
